
import React from "react"
import { Position } from "@ronuse/norseu/core/variables";
import { Navbar } from '@ronuse/norseu/core/overlay';
import { LinearLayout } from "@ronuse/norseu/layouts";
import { Accordion, Fieldset, ScrollPanel } from "@ronuse/norseu/core/panels";
import { HashRouter, NavLink, Route, Switch } from "react-router-dom";
import { IntroductionPage } from "./IntroductionPage";
import { GenerateSchemePage } from "../GenerateSchemePage";
import { UsedByPage } from "./UsedByPage";
import { ScratchPage } from "../ScratchPage";
import { ComponentsOverviewPage } from "./ComponentsOverviewPage";
import { ButtonPage } from "../core/buttons/ButtonPage";
import { createBrowserHistory } from "history";
import { DialogPage } from "../core/overlay/DialogPage";
import { ButtonGroupPage } from "../core/buttons/ButtonGroupPage";
import { CheckboxPage } from "../core/form/CheckboxPage";
import { DropdownPage } from "../core/form/DropdownPage";
import { FileInputPage } from "../core/form/FileInputPage";
import { InputTextPage } from "../core/form/InputTextPage";
import { PasswordInputPage } from "../core/form/PasswordInputPage";
import { TextAreaPage } from "../core/form/TextAreaPage";
import { InputFiltersPage } from "../core/form/InputFiltersPage";
import { AlertDialogPage } from "../core/overlay/AlertDialogPage";
import { PopoverPage } from "../core/overlay/PopoverPage";
import { NavbarPage } from "../core/overlay/NavbarPage";
import { MessagePage } from "../core/overlay/MessagePage";
import { PanelPage } from "../core/panels/PanelPage";
import { TabPanePage } from "../core/panels/TabPanePage";
import { FieldsetPage } from "../core/panels/FieldsetPage";
import { AccordionPage } from "../core/panels/AccordionPage";
import { ScrollPanelPage } from "../core/panels/ScrollPanelPage";

const history = createBrowserHistory({forceRefresh:true});

export class IndexPage extends React.Component {

	state = {
		username: ""
	}
	
	constructor(props) {
        super(props);
        this.state.isWideScreen = this.props.isWideScreen;
        this.state.navbarIsVisible = this.state.isWideScreen;
        this.props.setOnNavbarChange && this.props.setOnNavbarChange((hide) => {
            if (hide !== undefined) {
                if (!hide && this.state.navbarIsVisible) this.setState({ navbarIsVisible: false, isWideScreen: false });
                if (hide && !this.state.navbarIsVisible) this.setState({ navbarIsVisible: true, isWideScreen: true });
                return;
            }
            this.setState({ navbarIsVisible: !this.state.navbarIsVisible});
        });
	}

    hidenavbar() {
        if (this.state.isWideScreen) return;
        this.setState({navbarIsVisible: !this.state.navbarIsVisible});
    }

	render() {

		return (
            <HashRouter history={history}>
                <LinearLayout style={{ margin: 0, borderRadius: 0, width: "100%" }}>
                    <Navbar noOverlay={this.state.isWideScreen} className={`left-sidebar ${this.state.isWideScreen ? "wide" : ""}`} position={Position.LEFT} 
                        isVisible={this.state.navbarIsVisible} onHide={() => this.hidenavbar()}>
                        <ScrollPanel>
                            <section>
                                <span className="title">GENERAL</span>
                                <NavLink activeClassName="active" className="link" to="/p/introduction" onClick={() => this.hidenavbar()}>Introduction</NavLink>
                                {/* <NavLink activeClassName="active" className="link" to="/p/resources" onClick={() => this.hidenavbar()}>Resources</NavLink> */}
                                <NavLink activeClassName="active" className="link" to="/p/used_by" onClick={() => this.hidenavbar()}>Used By</NavLink>
                                {/* <NavLink activeClassName="active" className="link" to="/p/component_creator" onClick={() => this.hidenavbar()}>Component Creator</NavLink> */}
                                <NavLink activeClassName="active" className="link" to="/p/overview" onClick={() => this.hidenavbar()}>Overview</NavLink>
                                {/* <NavLink activeClassName="active" className="link" to="/scratch" onClick={() => this.hidenavbar()}>ScratchPad</NavLink> */}
                                {/* <NavLink activeClassName="active" className="link" to="/p/generate/scheme" onClick={() => this.hidenavbar()}>Create Scheme</NavLink> */}
                                
                                <span className="title">BUTTONS</span>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/buttons/button" onClick={() => this.hidenavbar()}>Button</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/buttons/buttongroup" onClick={() => this.hidenavbar()}>Button Group</NavLink>
                                
                                <span className="title">FORM</span>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/checkbox" onClick={() => this.hidenavbar()}>Checkbox</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/inputtext" onClick={() => this.hidenavbar()}>InputText</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/passwordinput" onClick={() => this.hidenavbar()}>PasswordInput</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/textarea" onClick={() => this.hidenavbar()}>TextArea</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/fileinput" onClick={() => this.hidenavbar()}>FileInput</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/inputfilters" onClick={() => this.hidenavbar()}>InputFilters</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/form/dropdown" onClick={() => this.hidenavbar()}>Dropdown</NavLink>
                                
                                <span className="title">OVERLAY</span>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/overlay/dialog" onClick={() => this.hidenavbar()}>Dialog</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/overlay/alertdialog" onClick={() => this.hidenavbar()}>AlertDialog</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/overlay/popover" onClick={() => this.hidenavbar()}>Popover</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/overlay/navbar" onClick={() => this.hidenavbar()}>Navbar</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/overlay/message" onClick={() => this.hidenavbar()}>Message</NavLink>
                                
                                <span className="title">PANELS</span>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/panels/panel" onClick={() => this.hidenavbar()}>Panel</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/panels/tabpane" onClick={() => this.hidenavbar()}>TabPane</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/panels/fieldset" onClick={() => this.hidenavbar()}>Fieldset</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/panels/accordion" onClick={() => this.hidenavbar()}>Accordion</NavLink>
                                <NavLink activeClassName="active" className="link" to="/p/components/core/panels/scrollpanel" onClick={() => this.hidenavbar()}>ScrollPanel</NavLink>
                            </section>
                        </ScrollPanel>
                    </Navbar>
                    <ScrollPanel style={{ flex: 1, minHeight: "90vh" }}>
                            <Switch>
                                <Route exact path="/p/introduction" component={IntroductionPage}/>
                                {/* <Route exact path="/p/resources" component={ResourcesPage}/> */}
                                <Route exact path="/p/used_by" component={UsedByPage}/>
                                <Route exact path="/p/overview" component={ComponentsOverviewPage}/>
                                <Route exact path="/p/scratch" component={ScratchPage}/>

                                <Route exact path="/p/components/core/buttons/button" component={ButtonPage}/>
                                <Route exact path="/p/components/core/buttons/buttongroup" component={ButtonGroupPage}/>

                                <Route exact path="/p/components/core/form/checkbox" component={CheckboxPage}/>
                                <Route exact path="/p/components/core/form/inputtext" component={InputTextPage}/>
                                <Route exact path="/p/components/core/form/passwordinput" component={PasswordInputPage}/>
                                <Route exact path="/p/components/core/form/textarea" component={TextAreaPage}/>
                                <Route exact path="/p/components/core/form/fileinput" component={FileInputPage}/>
                                <Route exact path="/p/components/core/form/inputfilters" component={InputFiltersPage}/>
                                <Route exact path="/p/components/core/form/dropdown" component={DropdownPage}/>
                                
                                <Route exact path="/p/components/core/overlay/dialog" component={DialogPage}/>
                                <Route exact path="/p/components/core/overlay/alertdialog" component={AlertDialogPage}/>
                                <Route exact path="/p/components/core/overlay/popover" component={PopoverPage}/>
                                <Route exact path="/p/components/core/overlay/navbar" component={NavbarPage}/>
                                <Route exact path="/p/components/core/overlay/message" component={MessagePage}/>
                                
                                <Route exact path="/p/components/core/panels/panel" component={PanelPage}/>
                                <Route exact path="/p/components/core/panels/tabpane" component={TabPanePage}/>
                                <Route exact path="/p/components/core/panels/fieldset" component={FieldsetPage}/>
                                <Route exact path="/p/components/core/panels/accordion" component={AccordionPage}/>
                                <Route exact path="/p/components/core/panels/scrollpanel" component={ScrollPanelPage}/>

                                <Route path="/p/generate/scheme" component={GenerateSchemePage}/>
                                {/* <Route exact path="/scratch" component={ScratchPage}/>
                                <Route exact path="/generate/scheme" component={GenerateSchemePage}/>
                                
                                <Route exact path="/components/core/variables/elevation" component={ElevationPage}/>
                                <Route exact path="/components/core/misc/tag" component={TagPage}/>
                                <Route exact path="/misc/badgeandtag" component={BadgeAndTagPage}/>

                                <Route exact path="/layouts/linearlayout" component={LinearLayoutPage}/>

                                <Route exact path="/sensors/viewportsensor" component={(props) => <ViewportSensorPage scrollContainerRef={componentDocumentationPanel} {...props}/>}/>
                                <Route exact path="/sensors/resizesensor" component={ResizeSensorPage}/> */}
                            </Switch>
                    </ScrollPanel>
                </LinearLayout>
            </HashRouter>
		)
	}
}
